import { BrowserRouter, Routes, Route, useParams, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Cart from "@/pages/Cart";
import PaymentSuccess from "@/pages/PaymentSuccess";
import CustomerDashboard from "@/pages/CustomerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import Quote from "@/pages/Quote";
import Contact from "@/pages/Contact";
import { Portfolio, Blog, BlogPost, CMSPage } from "@/pages/Content";
import { Services, Industries } from "@/pages/ServicesIndustries";
import FAQPage from "@/pages/FAQPage";
import AuthCallback, { ForgotPassword, ResetPassword } from "@/pages/AuthPages";
import TrackShipment from "@/pages/TrackShipment";
import Designer from "@/pages/Designer";
import Subscriptions from "@/pages/Subscriptions";

const BlogPostRoute = () => { const { slug } = useParams(); return <BlogPost slug={slug} />; };
const CMSPageRoute = ({ slug: fixed }) => { const params = useParams(); return <CMSPage slug={fixed || params.slug} />; };

function AppRouter() {
  const loc = useLocation();
  // Handle OAuth session_id in URL hash BEFORE anything else
  if (loc.hash && loc.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/services" element={<Services />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/printing" element={<Shop initialParent="printing" />} />
        <Route path="/graphic-design" element={<Shop initialParent="graphic_design" />} />
        <Route path="/website-design" element={<Shop initialParent="website_design" />} />
        <Route path="/product/:slug" element={<ProductDetail />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPostRoute />} />
        <Route path="/quote" element={<Quote />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/about" element={<CMSPageRoute slug="about" />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/policies/:slug" element={<CMSPageRoute />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<Cart />} />
        <Route path="/dashboard" element={<CustomerDashboard />} />
        <Route path="/track/:tracking_number" element={<TrackShipment />} />
        <Route path="/designer" element={<Designer />} />
        <Route path="/designer/:id" element={<Designer />} />
        <Route path="/subscriptions" element={<Subscriptions />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster position="bottom-right" />
            <AppRouter />
            <ChatWidget />
          </BrowserRouter>
        </CartProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}
